import { FieldWidthEnum } from '../../../cer/cer-data/cer-data-types';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class BankVendorForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'kreditorer', dataApiName: 'BankVendor', text: 'Kreditorer (betalinger)',
        primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, baseFields: ['id']
      },
      fieldMetadata:
        [
          { name: 'num', text: "Kreditorkonto", foreignKey: { navigations: [{ link: 'fk', foreignKey: { parentEntity: 'VendorView', parentColumn: 'num' } }] }},
          { name: 'name', text: "Kreditornavn" },
          { name: 'address1', text: "Addresse 1" },
          { name: 'address2', text: "Addresse 2" },
          { name: 'zipCity', text: "Postnr./By", visible: false },
          { name: 'townName', text: "By" },
          { name: 'country', fieldType: 'country' },
          { name: 'attention', text: "Attention", visible: false },
          { name: 'active', text: "Aktiv", format: 'CheckBox' },
          { name: 'currency', fieldType: 'currency' },
          { name: 'paymentType', text: "Betal.overførsel" },
          { name: 'paymentMode', text: "Betal.måde", visible: false },
          { name: 'paymentSpec', text: "Betal.spec.", visible: false },
          { name: 'bankAccountOCR', text: "FIK konto", width: '140px' },
          { name: 'bankAccountNum', text: "Bankkonto", width: '140px' },
          { name: 'bankSWIFT', text: "SWIFT", width: '120px' },
          { name: 'bankIBAN', text: "IBAN", width: '200px' },
          { name: 'bankName', text: "Bank navn" },
          { name: 'bankAddress1', text: "Bank adr. 1" },
          { name: 'bankAddress2', text: "Bank adr. 2" },
          { name: 'bankZipCity', text: "Bank postnr./by" },
          { name: 'bankAttention', text: "Bank attention", visible: false },
          { name: 'bankCountry', text: "Bank land", fieldType: 'country' },
          { name: 'bankPhone', text: "Bank telefon", format: 'Phone', visible: false },
          { name: 'latestInvoiceDate', text: "Seneste faktura", format: 'DateShort' },
          { name: 'latestPaymentDate', text: "Seneste betaling", format: 'DateShort' },
          { name: 'phone', text: "Telefon", format: 'Phone', visible: false },
          { name: 'email', text: "E-mail", format: 'Email', visible: false }
        ]
    });
  }
}
